





















































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import api from "@/getinfo-api";
import { VideoCreate as IVideoCreate } from "@/api/models/video-create";
import { Video as IVideo } from "@/api/models/video";
import { VideoEdit as IVideoEdit } from "@/api/models/video-edit";
import { EmployeesList2 as IEmployeesList2 } from "@/api/models/employees-list2";
import { Category as ICategory } from "@/api/models/category";
import { CategoryList as ICategoryList } from "@/api/models/category-list";
import EditorWithFile from "@/components/EditorWithFile.vue";
import { getCurrentUserId, isRoot } from "@/plugins/roles";
import SelectEntity from "@/components/form/SelectEntity.vue";
import employee, { EmployeeListParams } from "@/getinfo-api/employee";
import FileManager from "@/components/files/FileManager.vue";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import { User as IUser } from "@/api/models/user";
import categories, { CategoriesListParams } from "@/getinfo-api/categories";
import Modal from "@/components/form/Modal.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import { FileItem as IFileItem } from "@/api/models/file-item";
import CField from "@/components/form/CField.vue";
import CSingleSelect from "@/components/form/CSingleSelect.vue";
import { videoSrc } from "@/utils/get-src";
import { LearningMaterialLocales } from "@/plugins/custom-interface";

@Component({
  components: {
    CSingleSelect,
    CField,
    CustomButton,
    EditorWithFile,
    SelectEntity,
    FileManager,
    Modal
  }
})
export default class recordForm extends Vue {
  @Prop() video?: IVideo;
  companyId!: string;
  ownerId!: string;
  title!: string;
  body!: string | undefined;
  url!: string | undefined;
  enabled!: boolean | undefined;
  categoryId!: string;
  categoriesList!: Array<ICategory>;
  ownerProp?: any | undefined;
  limit: number = 30;
  offset: number = 0;
  showSpinner: boolean = false;
  price: number = 0;
  isShowFileManager: boolean = false;
  isDisabledButton: boolean = false;
  hours?: number = 0;
  employeesList!: Array<IUser>;
  locale: string = "";

  data() {
    return {
      employeesList: undefined,
      enabled: true,
      companyId: undefined,
      ownerId: undefined,
      title: this.$tc(this.$translate.Record),
      body: "",
      url: undefined,
      categoryId: undefined,
      categoriesList: undefined,
      ownerProp: undefined
    };
  }

  get locales() {
    return LearningMaterialLocales();
  }

  get screenWidth() {
    return window.innerWidth;
  }

  get selectedCompanyId() {
    const companyInStorage = localStorage.getItem("selectedCompany");
    return this.$store.getters.selectedCompany.id
      ? this.$store.getters.selectedCompany.id
      : companyInStorage;
  }

  get companyOwner() {
    return this.$store.getters.userIsCompanyOwner;
  }

  get root() {
    return isRoot();
  }

  formatter(value: string) {
    let src = videoSrc.getSrc(value);
    let host = process.env.VUE_APP_API_HOST;
    if (host?.endsWith("/")) {
      host = host.slice(0, -1);
    }

    if (!src?.startsWith("http") && value) {
      src = host + src;
    }

    return src;
  }

  setUrl(file: IFileItem) {
    this.url = file.url;
    this.isShowFileManager = false;
  }

  deleteVideo() {
    if (this.video) {
      api.VideoApi._delete(this.video.id)
        .then(() => {
          this.$router.push({ name: "records" });
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        });
    }
  }

  getEmployee() {
    if (this.selectedCompanyId) {
      if (this.root || this.companyOwner) {
        let params: EmployeeListParams = {
          id: this.selectedCompanyId,
          roles: ["content_manager"],
          limit: 200
        };

        employee(params)
          .then((res: { data: IEmployeesList2 }) => {
            this.employeesList = [];
            if (res.data.employees.length) {
              res.data.employees.forEach(element => {
                this.employeesList.push(element.user);
              });
              this.ownerId = this.video
                ? this.video?.owner?.id
                : this.employeesList[0].id;
            }
          })
          .catch(
            (err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
              this.$store.dispatch("errorException", {
                vm: this,
                error: err.response
              });
            }
          );
      } else {
        let params: EmployeeListParams = {
          id: this.selectedCompanyId,
          roles: ["content_manager"],
          limit: 200
        };

        employee(params)
          .then((res: { data: IEmployeesList2 }) => {
            this.employeesList = [];

            if (res.data.employees.length) {
              res.data.employees.forEach(element => {
                this.employeesList.push(element.user);
              });
              this.ownerId = getCurrentUserId();
            }
          })
          .catch(
            (err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
              this.$store.dispatch("errorException", {
                vm: this,
                error: err.response
              });
            }
          );
      }
    }
  }

  getAllCategories() {
    let params: CategoriesListParams = {
      companyId: this.selectedCompanyId,
      limit: 600
    };

    categories(params)
      .then((res: { data: ICategoryList }) => {
        this.categoriesList = res.data.items;
        if (!this.video && this.categoriesList[0] && this.categoriesList[0].id) {
          this.categoryId = this.categoriesList[0].id;
        }
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  mounted() {
    this.getEmployee();
    this.getAllCategories();
    if (this.video) {
      this.title = this.video.title;
      this.body = this.video.body;
      this.url = this.video.url;
      this.ownerId = this.video.ownerId;
      this.enabled = this.video.enabled;
      this.categoryId = this.video.category?.id ?? "";
      this.price = this.$converter.getPrice(this.video.price);
      this.hours = this.video.hours;
      this.locale = this.video?.locale ?? "";
      let params: EmployeeListParams = {
        id: this.video.companyId,
        userIds: [this.ownerId]
      };

      employee(params)
        .then((res: { data: IEmployeesList2 }) => {
          this.ownerProp = {
            companyId: this.video?.companyId,
            responsibleId: res.data.employees[0].id
          };
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        });
    }
  }

  async saveVideo() {
    if (await this.$store.dispatch("validate/CHECK_VALIDATIONS")) return;
    if (this.$store.getters.GET_FORM_IS_INVALID) {
      return;
    }
    this.isDisabledButton = true;
    if (!this.video) {
      let params: IVideoCreate = {
        companyId: this.selectedCompanyId,
        ownerId: this.ownerId,
        title: this.title,
        body: this.body,
        url: this.url,
        enabled: this.enabled,
        categoryId: this.categoryId,
        hours: this.hours,
        price: this.$converter.setPrice(this.price),
        locale: this.locale ?? ""
      };
      api.VideoApi.create(params)
        .then(() => {
          this.$router.push({ name: "records" });
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        })
        .finally(() => {
          this.isDisabledButton = false;
        });
    } else {
      let params: IVideoEdit = {
        ownerId: this.ownerId,
        title: this.title,
        body: this.body,
        url: this.url,
        enabled: this.enabled,
        hours: this.hours,
        categoryId: this.categoryId,
        price: this.$converter.setPrice(this.price),
        locale: this.locale ?? ""
      };
      api.VideoApi.edit(this.video.id, params)
        .then(() => {
          this.$router.push({
            name: "recordView",
            params: { id: this.$route.params.id }
          });
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        })
        .finally(() => {
          this.isDisabledButton = false;
        });
    }
  }
}
